import React, { useState, useEffect } from 'react';
import AdminNav from './AdminNav';
import './AdminTable.css';

import { API, authHeadersOnly } from '../services/apiConfig';

const STATUS_COLORS = {
  NEW: '#2563EB',
  IN_PROGRESS: '#D97706',
  RESOLVED: '#16A34A',
};

function ManageEnterpriseInquiries() {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  useEffect(() => { fetchInquiries(); }, []);

  const fetchInquiries = async () => {
    try {
      const res = await fetch(`${API}/api/enterprise`, { headers: authHeadersOnly() });
      const data = await res.json();
      setInquiries(Array.isArray(data) ? data : data.content ?? []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    await fetch(`${API}/api/enterprise/${id}/status?status=${status}`, { method: 'PUT', headers: authHeadersOnly() });
    fetchInquiries();
  };

  const deleteInquiry = async (id) => {
    if (!window.confirm('Delete this inquiry?')) return;
    await fetch(`${API}/api/enterprise/${id}`, { method: 'DELETE', headers: authHeadersOnly() });
    fetchInquiries();
  };

  return (
    <>
      <AdminNav onLogout={handleLogout} />
      <div className="admin-dashboard-wrapper">
        <div className="admin-dashboard-container">
          <div className="admin-hero-section">
            <h1 className="admin-hero-title">Enterprise Inquiries</h1>
            <p className="admin-hero-subtitle">Manage bulk and corporate gifting requests</p>
          </div>

          {loading ? (
            <p style={{ textAlign: 'center', color: '#888', padding: '60px' }}>Loading...</p>
          ) : inquiries.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#888', padding: '60px' }}>No inquiries yet.</p>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Company</th>
                    <th>Category</th>
                    <th>Requirement</th>
                    <th>Qty</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {inquiries.map((inq) => (
                    <tr key={inq.id}>
                      <td>{inq.id}</td>
                      <td>{inq.name}</td>
                      <td>{inq.email}</td>
                      <td>{inq.company || '—'}</td>
                      <td>{inq.category || '—'}</td>
                      <td style={{ maxWidth: '200px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{inq.requirement || '—'}</td>
                      <td>{inq.quantity || '—'}</td>
                      <td>{inq.createdAt ? new Date(inq.createdAt + 'Z').toLocaleDateString('en-IN', { dateStyle: 'medium', timeZone: 'Asia/Kolkata' }) : '—'}</td>
                      <td>
                        <span style={{
                          background: STATUS_COLORS[inq.status] + '22',
                          color: STATUS_COLORS[inq.status],
                          padding: '3px 10px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '600',
                        }}>
                          {inq.status}
                        </span>
                      </td>
                      <td>
                        <select
                          value={inq.status}
                          onChange={(e) => updateStatus(inq.id, e.target.value)}
                          style={{ fontSize: '12px', padding: '4px 8px', borderRadius: '8px', border: '1px solid #ddd', marginRight: '8px' }}
                        >
                          <option value="NEW">NEW</option>
                          <option value="IN_PROGRESS">IN_PROGRESS</option>
                          <option value="RESOLVED">RESOLVED</option>
                        </select>
                        <button
                          onClick={() => deleteInquiry(inq.id)}
                          style={{ background: '#FEE2E2', color: '#DC2626', border: 'none', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px' }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ManageEnterpriseInquiries;
